import { render } from "./PluginRadioGroup.vue?vue&type=template&id=b40a3fe0&scoped=true"
import script from "./PluginRadioGroup.vue?vue&type=script&lang=js"
export * from "./PluginRadioGroup.vue?vue&type=script&lang=js"

import "./PluginRadioGroup.vue?vue&type=style&index=0&id=b40a3fe0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\onix.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40a3fe0"]])

export default __exports__